import * as actionTypes from "../ActionTypes";
import { uniqBy } from "lodash";
import { minusHour } from "../actions/promotionCampaignAction";

const initialState = {
	success: false,
	loading: false,
	is_show: false,
	isExpired: false,
	isDisplay: false,
	isLive: false,
	products: [],
	active_campaign: null,
	page: 1,
	total_pages: 1,
	total_items: 1,
};

export const promotionCampaignReducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.Get_Active_Promotion_Campaign: {
			return {
				...state,
				active_campaign: action.payload,
				success: action.success,
			};
		}
		case actionTypes.Check_Show_Promotion_Campaign: {
			let displayAhead = new Date(
				minusHour(
					state?.active_campaign?.sale_promotion_campaign_product?.display_ahead,
					7
				)
			)?.getTime();

			let startDate = new Date(
				minusHour(
					state?.active_campaign?.sale_promotion_campaign_product?.start_date,
					7
				)
			)?.getTime();

			let now = new Date().getTime();

			return {
				...state,
				is_show:
					state?.active_campaign &&
					now >= displayAhead &&
					displayAhead <= startDate &&
					startDate >= now,
			};
		}
		case actionTypes.Reset_Active_Promotion_Campaign: {
			return {
				...state,
				active_campaign: action.payload,
				success: action.success,
			};
		}
		case actionTypes.Products_Campaign: {
			return {
				...state,
				products:
					state.page > 1
						? uniqBy([...state.products, ...action.payload.data.list], "item_id")
						: uniqBy(action.payload.data.list, "item_id"),
				total_pages: action.payload.data.totalPages,
				total_items: action.payload.data.totalItems,
				isExpired: action.payload.isExpired,
				isDisplay: action.payload.isDisplay,
				isLive: action.payload.isLive,
			};
		}
		case actionTypes.Change_Products_Campaign_Page: {
			return {
				...state,
				page: action.payload,
			};
		}
		case actionTypes.Reset_Products_Campaign_Page: {
			return {
				...state,
				page: 1,
				total_pages: 1,
			};
		}
		default: {
			return {
				...state,
			};
		}
	}
};
